<template>
  <div>
    <div v-if="action.processorName == 'PdfAndEmail'">
      <el-button
        type="primary"
        class="header-button"
        :icon="action.icon"
        @click="showDialogPdfAndEmail"
        >{{ translate(action.buttonTitle) }}</el-button
      >

      <el-dialog
        :title="getPdfAndEmailDialogTitle(action)"
        v-model="dialogFormVisible_PdfAndEmail"
      >
        <div v-for="(item, itemIdx) in getCustomFields" :key="itemIdx">
          <el-form-item :label="item.displayText" :title="item.displayText">
            <cc-var-control
              :metadata="{ id: 'value', type: getFinalControlType(item) }"
              :entity="item"
              property="value"
              :rootEntity="entity"
              :boldLabels="true"
            ></cc-var-control>
          </el-form-item>
        </div>

        <!-- <el-divider></el-divider> -->
        <template v-slot:footer>

        <span class="dialog-footer">
          <el-button
            href="javascript:void(0);"
            :loading="documentLoading"
            v-on:click="openDocument(buildFileDocumentId(action.action, entity))"
            :icon="Document"
            style="float: left; margin-left: 120px"
            >&nbsp;&nbsp;{{ translate(action.buttonTitle) }}</el-button
          >

          <el-button @click="dialogFormVisible_PdfAndEmail = false"
            >Cancel</el-button
          >
          <el-button type="primary" :loading="emailSending" @click="sendEmail"
            >Изпрати</el-button
          >
        </span>
        </template>
      </el-dialog>

    </div>
    <div v-else-if=" action.processorName == 'HtmlGenerator' || action.processorName == 'PdfGenerator' || action.processorName == 'XlsGenerator'">
      <div>
        <el-button
          type="primary"
          :size="size"
          class="header-button"
          :icon="action.icon"
          href="javascript:void(0);"
          :loading="documentLoading"
          v-on:click="openDocument(buildFileDocumentId(action.action, entity))"
          >{{ translate(action.buttonTitle) }}</el-button
        >
      </div>
    </div>
    <div v-else-if="action.processorName == 'Import'">
      
        <el-button
        
          type="primary"
          class="header-button"
          :icon="action.icon"
          href="javascript:void(0);"
          @click="showDialogImport"
          >{{ translate( action.buttonTitle )}}</el-button>

        <el-dialog
            :title="translate( action.buttonTitle )"
            v-model="dialogFormVisible_Import">


            <div v-for="(item, itemIdx) in getCustomFields" :key="itemIdx">
              <el-form-item :label="item.displayText" :title="item.displayText" >
                <cc-var-control
                  :metadata="{ id: 'value', type: 'input' }"
                  :entity="item"
                  property="value"
                  :rootEntity="entity"
                  :boldLabels="true"
                ></cc-var-control>
              </el-form-item>
            </div>

            <!-- <el-divider></el-divider> -->
            <template v-slot:footer>

            <span class="dialog-footer">
              <el-button type ="primary" @click="importObject">{{ action.displayText }}</el-button>


              <el-button @click="dialogFormVisible_Import = false">Cancel</el-button>
            </span>
            </template>


          </el-dialog>
      </div>
      <div v-else-if="action.processorName == 'UploadDocuments'">
         <el-upload
            :file-list="uploadDocuments_fileList"
            :action="uploadUrl"
            :headers="uploadHeaders"
            multiple
            :auto-upload="true"
            :on-change="onUploadDocumentsChange"
            :on-success="onUploadDocumentsSuccess"
            :on-error="onUploadDocumentsError"
            accept="application/pdf"
          >

          <el-button type="primary"
            class="header-button"
            :icon="action.icon"
            href="javascript:void(0);"
            >{{ action.buttonTitle }}</el-button>
            
            
          </el-upload> 
    </div>
    <div v-else-if="action.processorName == 'Other'">
          <el-button type="success"
            class="header-button"
            :icon="action.icon"
            href="javascript:void(0);"
            @click="onCustomActionOthers"
            >{{ action.buttonTitle }}</el-button>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Document } from '@element-plus/icons-vue'
import { markRaw } from 'vue'

import { ElLoading } from 'element-plus'
import { getToken } from '../../plugins/http'

import { apiUrl } from '../../config'
import { withPreparedCustomFields } from '@/utils/customActionFields.mjs'

export default {
  name: 'CcCustomActionButton',

  components: {},

  data() {
    return {
      dialogFormVisible_PdfAndEmail: false,
      dialogFormVisible_Import: false,
      documentLoading: false,
      emailSending: false,
      // Custom fields prepareCustomAction added to the current run of the action - sent, never shown.
      preparedCustomFields: [],
      uploadDocuments_fileList: [],
      uploadDocuments_errors: [],
      formLabelWidth: '200px',
      Document: markRaw(Document),
      __emailRecipients: undefined,
    }
  },

  props: {
    action: {},
    entity: {},
    filter: '',
    beforeCustomAction: Function,
    // Optional: (action) => Promise resolving extra custom fields for this run, or null to cancel it.
    prepareCustomAction: Function,
    afterCustomAction: Function,
    size: undefined,
  },

  computed: {
    getCustomFields() {
      var result = this.action && this.action.customFields
        ? this.action.customFields
        : []

      if(this.action.processorName == 'PdfAndEmail') {
        // These fields must always be present and shown first, in this order.
        const requiredFields = [
          { variableName: '@emailRecipients', displayText: 'To' },
          { variableName: '@emailSubject', displayText: 'Subject' },
          { variableName: '@emailBody', displayText: 'Body', input_type: 'textArea' },
        ]

        requiredFields.forEach(req => {
          if (!result.find(n => n.variableName == req.variableName)) {
            result.push({
              variableName: req.variableName,
              displayText: req.displayText,
              input_type: req.input_type,
              value: req.value !== undefined ? req.value : '',
            })
          }
        })

        result.find(r => r.variableName == '@emailBody').input_type='textArea'
        result.find(r => r.variableName == '@emailRecipients').value=this.__emailRecipients
        
        // Reorder: required fields first (in the order above), then the rest.
        // Array.prototype.sort is stable, so non-required fields keep their order.
        const orderOf = vn => {
          const i = requiredFields.findIndex(r => r.variableName == vn)
          return i < 0 ? requiredFields.length : i
        }
        result = result.slice().sort((a, b) => orderOf(a.variableName) - orderOf(b.variableName))
      }

      result.forEach(n => {
          if (n.formula) { 
            n.value = this.evaluateFormula(this.entity, n.formula)
          }
        })
        
      return result
    },

    uploadUrl() { 
      return `${apiUrl}/v1/upload?uploadType=orderComponentDocuments&entityId=${this.entity.id}`
    },

    uploadHeaders() { 
      return {
        Authorization: getToken()
      }
    }
  },

  watch: {
    'action': function () {
      this.recalcEmail()
    },
    'entity': function () {

      this.recalcEmail()
    },
  },

  methods: {
    recalcEmail() {
      var result = ''
      if (this.entity.customer) {
        result = this.entity.customer.emails[0].value
      } else if (this.entity.email) {
        result = this.entity.email
      }

      this.__emailRecipients = result
      //console.log(this.__emailRecipients)
    },

    // Wraps the global openFileDocument mixin method with a button-loading state
    // so the action button visibly disables while the v1/files request is in
    // flight. openFileDocument itself also drops duplicate in-flight requests
    // (see helpers.js), so this is belt-and-suspenders against double sends.
    openDocument(id) {
      this.documentLoading = true
      const done = () => { this.documentLoading = false }
      const p = this.openFileDocument(id)
      if (p && typeof p.finally === 'function') {
        p.finally(done)
      } else {
        done()
      }
    },

    getFinalControlType(item) {
      // todo - hack needs to be specified in database - temant actions jsonb
      switch (item.variableName) {
        case '@employeeName':
        case '@notes':
        case '@customerName':
        case '@leadTime':
        case '@leadTimeComments':
          return 'textArea'
      }

      return item.input_type ?? 'input'
    },

    showDialogPdfAndEmail() {
      this.preparedCustomFields = []
      if (this.beforeCustomAction) {
        this.beforeCustomAction().then(() => {
          this.openDialogPdfAndEmail()
        })
      } else {
        this.openDialogPdfAndEmail()
      }
    },

    // A form may add custom fields to this run of the action - the inquiry adds its offer's
    // quantity tiers - or cancel the run by resolving null.
    openDialogPdfAndEmail() {
      if (!this.prepareCustomAction) {
        this.dialogFormVisible_PdfAndEmail = true
        return
      }

      Promise.resolve(this.prepareCustomAction(this.action)).then((prepared) => {
        if (prepared === null) return
        this.preparedCustomFields = prepared || []
        this.dialogFormVisible_PdfAndEmail = true
      })
    },

    showDialogImport() {
      if (this.beforeCustomAction) {
        this.beforeCustomAction().then(() => {
          this.dialogFormVisible_Import = true
        })
      } else {
        this.dialogFormVisible_Import = true
      }
    },

    showCustomActionDialog() {
      if (this.action.processorName == 'PdfAndEmail') {
        this.dialogFormVisible_PdfAndEmail = true
      } else {
        console.error(
          `Unsupported custom action button: '${this.action.processorName}'`
        )
      }
    },

    sendEmail() {
      // Guard against double-clicks: disable the send button while the request
      // is in flight so the same email is not sent to the supplier 2-4 times.
      if (this.emailSending) return
      this.emailSending = true

      this.$http
        .post('v1/customactions', {
          action: this.action.action,
          customFields: withPreparedCustomFields(this.action.customFields, this.preparedCustomFields),
          itemId: this.entity.id,
        })
        .then((res) => {
          this.dialogFormVisible_PdfAndEmail = false

          if (this.afterCustomAction)
            this.afterCustomAction(this.action)

          this.$swal('Done', this.translate('Email was sent.'), 'success')
        })
        .catch((error) => {
          this.showApiError(error)
        })
        .finally(() => {
          this.emailSending = false
        })
    },

    importObject() { 

      const loadingInstance = ElLoading.service({
        lock: true,
        text: 'Loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })

      this.$http
        .post('v1/customactions', {
          action: this.action.action,
          data: {},
          customFields: this.action.customFields,
          itemId: this.entity.id,
        })
        .then((res) => {
          // this.setFetching({ fetching1: false })
          loadingInstance.close()

          this.dialogFormVisible_Import = false

          if (this.afterCustomAction)
            this.afterCustomAction(this.action)

          this.$swal('Done', this.translate('Successfully Imported.'), 'success')
        })
        .catch((error) => {
          // this.setFetching({ fetching: false })
          loadingInstance.close()
          this.showApiError(error)
        })
        
    },

    onCustomActionOthers() {
      var confirmMessage = this.action.customFields.find(n=>n.variableName=='confirmMessage').displayText
      const item = this.entity
      this.$swal({
        title: this.translate('Are you sure?'),
        text: this.translate(confirmMessage),
        icon: 'warning',
        showCancelButton: true,
      }).then((result) => {
        if (result && result.isConfirmed) {
          this.$http
            .post('v1/customactions', {
              action: this.action.action,
              data: {},
              customFields: this.action.customFields,
              itemId: this.entity.id,
            })
            .then((res) => {
              if (this.afterCustomAction)
                this.afterCustomAction(this.action)
            })
            .catch((error) => {
              this.showApiError(error)
            })
        }
      })
    },

    evaluateFormula(item, formula) {
      try {
        return eval(formula)
      } catch (e) {
        console.error('ERROR: evaluateFormula:')
        console.error(e.message)
        return undefined
      }
    },

    getItemDisplayName(itm) {
      if (itm.name) {
        return itm.name
      } else if (itm.component && itm.component.name) {
        // custom for order compoent's
        return itm.component.name
      } else {
        return itm.id
      }
    },

    buildFileDocumentId(actionName, item) {
      var result = `action=${actionName}`

      const fields = withPreparedCustomFields(this.action && this.action.customFields, this.preparedCustomFields)
      if (fields && fields.length) {
        var customFields = ''
        fields.forEach((n) => {
          // Percent-encode CR/LF so newlines survive transport in the v1/files/{id}
          // URL path (a raw newline in a URL is stripped in transit). The backend
          // reverses this with Uri.UnescapeDataString (FilesController). We must NOT
          // encode the structural delimiters (: ; & =) here — the routing layer would
          // decode them back and corrupt parsing — so keep the existing escaping as-is.
          const val = n.value != null && n.value !== ''
            ? String(n.value)
                .replace(/[\/?]/g, c => `%${c.charCodeAt(0).toString(16)}`)
                .replace(/[&=]/g, c => '_')
                .replace(/\r/g, '%0D')
                .replace(/\n/g, '%0A')
            : '';
          customFields += `${n.variableName}:${val};`
        })
        result += `&customFields=${customFields}`
      }

      if (this.filter && this.filter.length) {
        var idx = this.filter.indexOf('?')
        var filter = idx > 0 ? this.filter.substring(idx + 1) : ''
        result += `&${filter}`
      } else if (Array.isArray(item)) {
        var ids = ''
        item.forEach((n) => {
          ids += `${n.id}_`
        })
        result += `&ids=${ids}`
      } else {
        result += `&ids=${item.id}`
      }

      return result
    },

    getPdfAndEmailDialogTitle(action) {
      return `${this.translate('Send of')} ${this.translate(action.buttonTitle)} `
    },

    onUploadDocumentsChange() { 
    },

    onUploadDocumentsSuccess(response, _, uploadFiles) { 
      const count = uploadFiles.length + this.uploadDocuments_errors.length
      const successCount = uploadFiles.length
      var message = `${successCount} of ${count} files uploaded.`
      if (this.uploadDocuments_errors.length > 0) { 
        message += '<br/>Messages:<br/>'
        this.uploadDocuments_errors.forEach(err=>message+=err +'\r\n')
      }

      this.uploadDocuments_fileList = []
      this.uploadDocuments_errors = []

      if (this.afterCustomAction)
        this.afterCustomAction(this.action)

      this.$swal('Done', message, 'success')
    },

    onUploadDocumentsError(error) {
      this.uploadDocuments_errors.push(error)
    },
  },
}
</script>

<style lang="scss">
.dialog-table-cell {
  padding: 5px;
}


</style>
